
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class ModellingViewFormatDialog extends SiteEntityDialog<ModellingViewFormatRow, any> {
        protected getFormKey() { return ModellingViewFormatForm.formKey; }
        protected getIdProperty() { return ModellingViewFormatRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewFormatRow.localTextPrefix; }
        protected getNameProperty() { return ModellingViewFormatRow.nameProperty; }
        protected getService() { return ModellingViewFormatService.baseUrl; }

        protected form = new ModellingViewFormatForm(this.idPrefix);

    }
}